import { useNavigate } from "react-router-dom";

const Services = () => {
  const navigate = useNavigate();
  const handleScroll = (elementDiv: any) => {
    const element = document.getElementById(elementDiv);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" }); // 'auto' for instant scroll
    }
    navigate(`/${elementDiv}`);
  };

  const servicesData = [
    {
      title: "Homeowner<br/>Login",
      image: "assets/img/services/s1.png",
      detail: "Unlock the full potential of homeownership with our convenient homeowner portal. Easily manage payments, track updates, and access important community information all in one secure place. Stay connected, informed, and in control with just a few clicks.",
      goto: 'portal'
    },
    {
      title: "Pay Your<br/>Bill",
      image: "assets/img/services/s2.png",
      detail: "It's our goal to make your life easier. You can now pay your bill online and get back to enjoying your family & community.",
      goto: 'portal'
    },
    {
      title: "Service<br/>Request",
      image: "assets/img/services/s3.png",
      detail: "Giving you the best quality customer service is our top priority. We are happy to help with your service request to make our community thrive.",
      goto: 'contact-us'
    },
    {
      title: "Escrow<br/>Services",
      image: "assets/img/services/s4.png",
      detail: "Make the home selling process easy and seamless. Our streamlined process minimizes delays, ensuring a smooth, hassle-free transaction every time.",
      goto: 'contact-us'
    },
  ];


  return (
    <div className="services" id="about-us">
      <div className="service-section">
        {servicesData.map((service: any, key: number) => {
          return (
            <div className="box" key={key}>
              <div className="box-detail">
                <div className="image-wrapper">
                  <img src={service.image} alt="..." />
                </div>
                <div className="service-name" dangerouslySetInnerHTML={{ __html: service.title }}></div>
                <div className="service-detail">{service.detail}</div>
                <div>
                <button type="button" onClick={() => {
                  if (service.goto === 'portal') {
                    window.open('https://portal.abmpropertymgmt.com/login', '_blank');
                  } else {
                    handleScroll("contact-us");
                  }
                }} className="btn btn-outline-primary learn-morn-btn">
                  Learn More
                </button>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default Services;
